import { connect } from "react-redux";

import { HydrovacTicket } from "../../interface/api/HydrovacTicket";
import hydrovacTicketService from "../../services/hydrovacTicketService";
import { useDigitalTicket } from "../../hooks/useDigitalTicket";
import TicketLoading from "../shared/ticket-loading";
import HydrovacPrintableTicket from "./hydrovac-printable-ticket";

/**
 * /hydrovac-digital-ticket/:id - the printable ticket, staff only. Read-only by
 * design: every edit path lives on /hydrovac/:id.
 */
const HydrovacDigitalTicketView = () => {
  const { ticket, ticketUrl } = useDigitalTicket<HydrovacTicket>(
    hydrovacTicketService,
    "hydrovac"
  );

  if (!ticket) return <TicketLoading />;

  return <HydrovacPrintableTicket ticket={ticket} ticketUrl={ticketUrl} />;
};

export default connect()(HydrovacDigitalTicketView);
